import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=0c1844ff&scoped=true&"
import script from "./tooltip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./tooltip.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./tooltip.vue?vue&type=style&index=0&id=0c1844ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1844ff",
  null
  
)

export default component.exports